import { render, staticRenderFns } from "./ball.vue?vue&type=template&id=59d6dff1&scoped=true&"
var script = {}
import style0 from "./ball.vue?vue&type=style&index=0&id=59d6dff1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d6dff1",
  null
  
)

export default component.exports